import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import { Suspense } from "react";

const resources = {
  nl: {
    translation: {
      "nav.property_listing": "Woningaanbod",
      "nav.rent": "Huren",
      "nav.rent_out": "Verhuren",

      "profile.profile": "Profiel",
      "profile.applications": "Aanmeldingen",
      "profile.logout": "Uitloggen",
      "profile.repairrequest": "Reparatieverzoek",
      "profile.landlord-statement": "Verhuurdersverklaring",
      "profile.lease-termination": "Huuropzegging",
      "profile.screening_profile": "GoHome ID",

      "profile.name": "Naam",
      "profile.firstname": "Voornaam",
      "profile.surname": "Achternaam",
      "profile.phone": "Telefoonnummer",
      "profile.dateofbirth": "Geboortedatum",
      "profile.shared_income": "Gezamenlijk inkomen",
      "profile.email": "E-mail",
      "profile.upgrade_button": "Afrekenen",
      "profile.upgrade": "Upgraden naar premium",
      "profile.edit_profile": "Profiel bewerken",
      "profile.basic_account": "Basis account",
      "profile.premium_account": "Premium account",
      "profile.basic_price": "Gratis",
      "profile.unlimited": "Onbeperkt",
      "profile.feature1":
        "Ontvang altijd 1 uur eerder een uitnodiging voor de bezichtiging en krijg als eerste de kans een woning te bezichtigen.",
      "profile.feature2": "Direct toegang tot beschikbaar aanbod",
      "profile.signup": "Registreren",
      "profile.annualy": "eenmalig",
      "profile.title": "Aanmelden als huurder",
      "profile.create_landlord_account": "Verhuurdersaccount Aanmaken",
      "profile.most_chosen": "Meest gekozen",
      "profile.back": "Terug naar overzicht",
      "profile.your_details": "Jouw gegevens",
      "profile.contact": "Contact",
      "profile.address": "Adres",
      "profile.province": "Provincie",
      "screening_profile.missing_information": "Ontbrekende informatie",
      "screening_profile.renter_number": "Huurder {{number}}",
      "screening_profile.guarantor_number": "Garantsteller {{number}}",
      "screening_profile.main_renter": "Hoofdhuurder",
      "screening_profile.incomplete": "Incompleet",
      "screening_profile.make_main_renter": "Maak hoofdhuurder",
      "screening_profile.firstname": "Voornaam",
      "screening_profile.surname": "Achternaam",
      "screening_profile.email": "E-mail",
      "screening_profile.phone": "Telefoonnummer",
      "screening_profile.birthdate": "Geboortedatum",
      "screening_profile.birthplace": "Geboorteplaats",
      "screening_profile.street": "Straat",
      "screening_profile.house_number": "Huisnummer",
      "screening_profile.postal_code": "Postcode",
      "screening_profile.city": "Stad",
      "screening_profile.country": "Land",
      "screening_profile.province": "Provincie",
      "screening_profile.income": "Inkomen",
      "screening_profile.employment_type": "Type werkgelegenheid",
      "screening_profile.screening_type": "Type screening",

      "createAccount.firstname": "Voornaam",
      "createAccount.lastName": "Achternaam",
      "createAccount.email": "E-mail",
      "createAccount.phone": "Telefoonnummer",
      "createAccount.password": "Wachtwoord",
      "createAccount.confirm_password": "Bevestig wachtwoord",
      "createAccount.terms1": "Ik ga akkoord met de",
      "createAccount.terms2": "algemene voorwaarden",
      "createAccount.createAccount": "Account aanmaken",
      "createAccount.how_it_works": "Hoe werkt het?",
      "createAccount.account": "Account",
      "createAccount.account.text":
        "Maak eenvoudig een account aan en zet de eerste stappen richting jouw nieuwe huurwoning. Plan direct een bezichtiging in of meld je aan als geïnteresseerde.",
      "createAccount.planning": "Plannen",
      "createAccount.planning.text":
        "Je hebt een mooie huurwoning gezien en zou deze graag willen bezichtigen. Via ons platform plan je binnen de beschikbaar gestelde momenten een bezichtiging in.",
      "createAccount.viewing": "Bezichtiging",
      "createAccount.viewing.text":
        "Een van onze viewers zal de bezichtiging begeleiden zodat je een optimaal beeld krijgt van de woning. Lukt het niet om er fysiek bij te zijn? Geen probleem! Wij sturen jou een video.",
      "createAccount.register": "Inschrijven",
      "createAccount.register.text":
        "Na de bezichtiging ontvang je een uitnodiging om jouw aanmelding te voltooien. Wij starten het screeningsproces om zeker te beoordelen of jij in aanmerking komt voor de woning.",
      "createAccount.contract": "Contract",
      "createAccount.contract.text":
        "Is de woning aan jou toegewezen? Gefeliciteerd! De huurovereenkomst  wordt direct opgesteld en online getekend. Zo is alles snel geregeld en ben je klaar om te verhuizen.",
      "createAccount.checkin": "Sleuteloverdracht",
      "createAccount.checkin.text":
        "Na ondertekening plannen een moment voor de sleuteloverdracht. We leggen de staat van de woning digitaal vast in een inspectierapport en dragen de sleutels aan jou over. Let's GoHome!",

      "signin.login_as_landlord": "Log in als Verhuurder",
      "signin.email": "E-mail",
      "signin.password": "Wachtwoord",
      "signin.forgot_password": "Wachtwoord vergeten",
      "signin.login": "Inloggen",
      "signin.forgot_password_description":
        "Vul hieronder je e-mailadres in, en we sturen je instructies om je wachtwoord opnieuw in te stellen. Zorg ervoor dat je het e-mailadres invoert dat je bij je account hebt geregistreerd.<br/><br/>Na het versturen ontvang je binnen enkele minuten een e-mail met een link om je wachtwoord te resetten. Controleer ook je spammap als je de e-mail niet ziet verschijnen.",
      "signin.create_account": "Account aanmaken",
      "signin.or": "of",
      "signin.remember_me": "Onthoud mij",

      "createdProfile.premium.text":
        "Bedankt voor jouw aanmelding als Premium huurder! We kijken er naar uit om jou te helpen in de zoektocht naar jouw nieuwe woning. We hebben je een mail gestuurd om jouw account te verifiëren. Dit kan enkele minuten duren.",
      "createdProfile.basic.text":
        "We kijken er naar uit jou te helpen in de zoektocht naar jouw nieuwe woning. We hebben je een mail gestuurd om jouw account te verifiëren.<br><br>Dit kan enkele minuten duren.",

      "verified.title": "Jouw account is geactiveerd!",
      "verified.subtitle":
        "Begin direct de zoektocht naar jouw nieuwe woning. Via jouw persoonlijke huurder dashboard heb je altijd inzicht in de status van de woningen binnen jouw selectie.",
      "verified.list-title": "Begin jouw zoektocht zo:", //!Ask if this needs to be changed
      "verified.list-item1": "Geef je interesse aan",
      "verified.list-item2":
        "Meld je aan voor een fysieke bezichtiging, of voor een videobezichtiging",
      "verified.list-item3":
        "Maak jouw huurdersprofiel door middel van de screening compleet",
      "verified.questions":
        "Mocht je vragen of hulp nodig hebben bij het gebruik van jouw account, neem dan contact op via support@gohome.rent. Ons team staat klaar om je te helpen!",

      "profile.view_property": "Woning bekijken",
      "profile.to_screening": "Screening invullen",
      "profile.view_screening": "Screening bekijken",

      "overview.recently_rented": "Recent verhuurd",
      "overview.available_from": "Beschikbaar vanaf",
      "overview.directly_available": "Per direct beschikbaar",
      "overview.available_soon": "Binnenkort beschikbaar",
      "overview.apply_filter": "Filter toepassen",
      "overview.reset": "Reset",
      "overview.rooms": "Kamers",
      "overview.price": "Prijs",
      "overview.location": "Locatie",
      "overview.city": "Plaats",
      "overview.sort_by": "Sorteer op",
      "overview.minimum": "Minimaal",
      "overview.maximum": "Maximaal",
      "overview.result": "Resultaat",
      "overview.results": "Resultaten",
      "overview.map": "Kaart",
      "overview.list": "Lijst",
      "overview.tab_properties": "Woningen",
      "overview.tab_collections": "Complexen",

      "complex.sidebar.title": "Complex overzicht",
      "complex.sidebar.availableProperties1": "Van de",
      "complex.sidebar.availableProperties2":
        "huizen in dit project zijn er nog",
      "complex.sidebar.availableProperties3": "beschikbaar",
      "complex.types.availableApartments": "Appartementen beschikbaar",
      "complex.card.available": "beschikbaar",
      "complex.card.of": "van",

      "details.read_more": "Meer lezen",
      "details.read_less": "Minder lezen",
      "details.subscribe_video": "Aanmelden voor woning video",
      "details.attending_video": "Aangemeld voor woning video",

      "select.date_desc": "Datum toegevoegd - Aflopend",
      "select.price_asc": "Prijs - Oplopend",
      "select.price_desc": "Prijs - Aflopend",

      "details.deposit": "Borg",
      "details.furnished": "Gestoffeerd",
      "details.description": "Omschrijving",
      "details.all_photos": "Alle foto's bekijken",
      "details.landlord": "Verhuurder",
      "details.apartment": "Woning",
      "details.rental_conditions": "Huurvoorwaarden",
      "details.bedrooms": "slaapkamer",
      "details.bathrooms": "badkamer",
      "details.furnishedDecorated": "Gemeubileerd",

      "viewing.subscribeText_interested":
        "Bedankt voor je interesse in deze woning. Wanneer er een bezichtiging wordt ingepland, ontvang je hiervan bericht. ",
      "viewing.subscribeText_default":
        "Op dit moment is er geen bezichtiging gepland voor deze woning. Schrijf je in om een melding te krijgen als er een bezichtiging beschikbaar is.",
      "viewing.plan_viewing": "Bezichtiging plannen",
      "viewing.recently_rented": "Deze woning is recent verhuurd.",
      "viewing.show_interest": "Interesse tonen",
      "viewing.subscribed": "Aangemeld",
      "viewing.login_or_create_account":
        "Log in of maak een (gratis) account aan om een bezichtiging te plannen.",
      "viewing.createAccount": "Account aanmaken",
      "viewing.or": "of",
      "viewing.all-events-booked": "Alle evenementen zijn geboekt",
      "viewing.video_viewing": "Woning video",
      "viewing.upgradeAccount-title": "Profiteer van de voordelen",
      "viewing.upgradeAccount-text":
        "Voor veel van de aangeboden woningen is er meer interesse dan beschikbare bezichtingingsplekken. Met een premium account krijg je een uur eerder de mogelijkheid om je spot te claimen en nog vele andere voordelen.",
      "viewing.upgradeAccount-button": "Upgrade naar premium",

      "book-viewing.title":
        "Interesse in deze woning? Meld u aan voor een bezichtiging en ontdek de mogelijkheden.",
      "book-viewing.loading": "Inschrijving wordt verwerkt",

      "viewing.video_viewing.text":
        "Wij maken ook een woningvideo. Vraag deze aan, dan sturen we deze per mail zodra hij beschikbaar is.",

      "timeslots.unsubscribe": "Uitschrijven",
      "timeslots.openDialog.text":
        "Wilt u zich afmelden voor deze bezichtiging?",
      "timeslots.handleBookTimeslot.title": "Bezichtiging boeken",
      "timeslots.handleBookTimeslot.text":
        "Weet u zeker dat u deze bezichtiging wilt boeken van",
      "timeslots.handleBookTimeslot.to": "tot",
      "timeslots.available-timeslots": "plaatsen beschikbaar",

      "accountform.error.fields": "Alle velden moeten worden ingevuld.",
      "accountform.error.invalidPassword":
        "Het wachtwoord moet minimaal 8 tekens lang zijn, minimaal één cijfer bevatten, minimaal één hoofdletter, minimaal één kleine letter en minimaal één speciaal teken bevatten.",
      "accountform.error.passwordsDontMatch":
        "Wachtwoorden komen niet overeen.",
      "accountform.error.terms":
        "Om een account aan te kunnen maken moeten de algemene voorwaarden geaccepteerd worden.",

      "dates.month": "Maand",
      "dates.year": "Jaar",

      "applications.none": "Nog geen aanmeldingen",

      "phase.Rejected": "Geïnteresseerd",
      "phase.Rejected.text":
        "Bedankt voor je interesse.<br/><br/>We plannen binnenkort een bezichtiging in. Wanneer de bezichtiging is ingepland ontvang je hiervan bericht en kun je je aanmelden voor een tijdslot.<br/><br/>Als je je niet meer kunt aanmelden voor een tijdslot, kun je een videobezichtiging aanvragen.",

      "phase.interested": "Geïnteresseerd",
      "phase.interested.text":
        "Bedankt voor je interesse.<br/><br/>We plannen binnenkort een bezichtiging in. Wanneer de bezichtiging is ingepland ontvang je hiervan bericht en kun je je aanmelden voor een tijdslot.<br/><br/>Als je je niet meer kunt aanmelden voor een tijdslot, kun je een videobezichtiging aanvragen.",

      "phase.videoviewing": "Video Bezichtiging",
      "phase.videoviewing.text":
        "Je bent aangemeld voor de (video)bezichtiging.<br/><br/>De video wordt automatisch naar je email verstuurd zodra deze beschikbaar is.",
  
      "phase.viewing": "Bezichtiging",
      "phase.viewing.text":
        "Je bent aangemeld voor de bezichtiging.<br/><br/>Zorg dat je op tijd bent voor je bezichtiging en wacht tot onze Viewer je binnenlaat.",

      "phase.screening_invited": "Uitgenodigd voor screening",
      "phase.screening_invited.text":
        "Je kunt je screeningsformulier nu invullen.<br/><br/>Doe dit zo snel mogelijk, zodat wij kunnen beoordelen of je in aanmerking komt voor de woning. Mocht je nog niet alle documenten beschikbaar hebben, dan kun je het screeningsformulier sluiten en later heropenen.<br/><br/>Wijzigingen worden tussentijds opgeslagen.",

      "phase.screening": "Screening",
      "phase.screening.text":
        "Bedankt voor het indienen van al je gegevens, wij zijn bezig met de screening.<br/><br/>Het screeningsproces duurt gemiddeld 10 werkdagen. We nemen contact met je op als we meer informatie nodig hebben.",
  
      "phase.datakeeper_invited": "Uitgenodigd voor datakeeper",
      "phase.datakeeper_invited.text":
        "Iedere huurder en garantsteller ingevuld bij de screening heeft een mail ontvangen met een uitnodiging om via datakeeper je gegevens te delen met GoHome.",
    
      "phase.datakeeper_completed": "Datakeeper voltooid",
      "phase.datakeeper_completed.text":
        "Bedankt voor het indienen van al je gegevens, wij zijn bezig met het verwerken van datakeeper.<br/><br/>Het screeningsproces duurt gemiddeld 10 werkdagen. We nemen contact met je op als we meer informatie nodig hebben.",
  
      "phase.assigned": "Woning toegewezen",
      "phase.assigned.text":
        "De verhuurder heeft voor jou gekozen als nieuwe huurder.<br/><br/>Wij nemen binnenkort contact met je op om de huurvoorwaarden door te nemen, waarna jij de woning definitief kan accepteren.",
  
      "phase.contract": "Contract",
      "phase.contract.text":
        "Het contract wordt opgesteld.<br/><br/>Zodra het contract gereed is, ontvang je per mail een DocuSign-verzoek om jouw huurovereenkomst digitaal te ondertekenen.",
  
      "phase.checkin": "Sleuteloverdracht",
      "phase.checkin.text":
        "Het contract is getekend, gefeliciteerd!<br/><br/>Wij nemen spoedig contact met je op om de sleuteloverdracht in te plannen.",

      "phase.rented": "Gehuurd",
      "phase.rented.text": "Wij wensen je veel woonplezier!",

      "footer.work_at": "Werken bij GoHome?",
      "footer.about": "Over ons",
      "footer.jobs": "Vacatures",
      "footer.knowledge_base": "Kenniscentrum",
      "footer.faq": "Veelgestelde vragen",
      "footer.conditions": "Algemene voorwaarden",
      "footer.privacy": "Privacybeleid",

      "specifications.living_area": "Woonoppervlakte",
      "specifications.plot_area": "Oppervlakte perceel",
      "specifications.floors": "Aantal woonlagen",
      "specifications.rooms": "Aantal kamers",
      "specifications.bedrooms": "Aantal slaapkamers",
      "specifications.bathrooms": "Aantal badkamers",
      "specifications.bathroom_amenities": "Voorzieningen badkamer",
      "specifications.toilet": "Apart toilet",
      "specifications.outdoor_space": "Buitenruimte",
      "specifications.garage": "Garage",
      "specifications.shed": "Schuur/berging",
      "specifications.parking": "Parkeergelegenheid",
      "specifications.construction": "Bouwsoort",
      "specifications.date_available": "Beschikbaar per",
      "specifications.rental_period": "Verhuurperiode",
      "specifications.deposit": "Waarborgsom",
      "specifications.service_charge": "Servicekosten",
      "specifications.heating_cost": "Stookkosten",
      "specifications.tv_internet": "Televisie en internet",
      "specifications.furnished_decorated": "Gestoffeerd",
      "specifications.furniture": "Gemeubileerd",
      "specifications.sharing": "Woning delen",
      "specifications.pets": "Huisdieren",
      "specifications.smoking": "Roken",
      "specifications.energy_label": "Energielabel",

      "rentalperiod.fixed": "Bepaalde tijd",
      "rentalperiod.indefinite": "Onbepaalde tijd",
      "rentalperiod.with_option": "Bepaalde tijd met optie tot onbepaalde tijd",

      "screening.document.identiteitsbewijs_-_voorkant":
        "één van de volgende documenten waarvan de vervaldatum nog niet verstreken is: Rijbewijs (NL), ID kaart (Internationaal), Paspoort (Internationaal)",
      "screening.document.identiteitsbewijs_-_achterkant":
        "één van de volgende documenten waarvan de vervaldatum nog niet verstreken is: Rijbewijs (NL), ID kaart (Internationaal), Paspoort (Internationaal)",
      "screening.document.recente_werkgeversverklaring":
        "een werkgeversverklaring die niet ouder is dan 3 maanden. Zorg dat alles door jouw werkgever volledig is ingevuld",
      "screening.document.bankafschrift":
        "een bankafschrift waarop bijschrijving van jouw salaris van de afgelopen 3 maanden te zien is",
      "screening.document.kopie_bankpas":
        "een kopie van jouw bankpas die overeenkomst met het bankafschrift",
      "screening.document.loonstrook_1":
        "jouw laatst beschikbare loonstrook",
      "screening.document.loonstrook_2":
        "een loonstrook van maximaal 2 maanden oud",
      "screening.document.loonstrook_3":
        "een loonstrook van maximaal 3 maanden oud",
      "screening.document.kopie_arbeidsovereenkomst":
        "een kopie van jouw getekende arbeidsovereenkomst indien je een nieuwe baan hebt",
      "screening.document.aangifte_inkomstenbelasting":
        "hier jouw verzonden aangifte inkomstenbelasting voor jaar 2023",
      "screening.document.verhuurdersverklaring":
        "hier een verklaring van jouw verhuurder waaruit blijkt dat er geen huurachterstand is en dat er nooit overlast is geweest. Indien jouw verhuurder niet beschikbaar is, upload dan een bankafschrift waarop de laatste 6 maanden aan huurbetalingen te zien zijn.  ",
      "screening.document.uittreksel_brp":
        "hier een gewaarmerkt uittreksel uit de Basisregistratie Personenregister. Dit kun je opvragen bij jouw eigen gemeente.",
      "screening.document.uittreksel_uwv":
        "hier een recent uittreksel van het UWV.",
      "screening.document.kvk_uittreksel":
        "een recent gewaarmerkt uittreksel van de Kamer van Koophandel.",
      "screening.document.ib60_formulier":
        "jouw meest recente IB60 formulier. Deze kun je aanvragen bij de belastingdienst.",
      "screening.document.balans_winstverliesrekening":
        "jouw meest recente winst-verlies rekening en de balans van de afgelopen 3 jaar.",
      "screening.document.recente_aow-strook":
        "jouw meest recente AOW strook.",

      "datakeeper.intro":
        "Om je gegevens veilig op te halen, gebruiken we Datakeeper. Dit is alleen beschikbaar voor gebruikers met DigiD. Selecteer de optie die op jou van toepassing is:",
      "datakeeper.qrcode":
        "Door de QR-code te scannen, word je doorgestuurd naar Datakeeper. Het ophalen van je gegevens kan enkele minuten duren. De pagina wordt automatisch bijgewerkt zodra het proces is voltooid.",
      "datakeeper.digid.yes": "Ik heb DigiD",
      "datakeeper.digid.no": "Ik heb geen DigiD",
      "datakeeper.noDigid1":
        "Als je geen DigiD hebt, kunnen we je gegevens niet bevestigen met Datakeeper.",
      "datakeeper.noDigid2":
        "Dit kan resulteren in een langere verwerkingstijd.",
      "datakeeper.title": "Screening voor",
      "datakeeper.completed":
        "We hebben je screeninggegevens ontvangen! We nemen contact met je op zodra we je gegevens hebben verwerkt.",

      Yes: "Ja",
      No: "Nee",

      Allowed: "Toegestaan",
      "Not Allowed": "Niet toegestaan",

      Apartment: "Appartement",
      Studio: "Studio",
      House: "Huis",
      Storage: "Opslag",

      "No energy label": "Geen energielabel",

      "Existing Building": "Bestaand gebouw",
      "New Construction": "Nieuwbouw",

      "1.5 x Monthly Rent": "1.5 x Maandhuur",
      "1 x Monthly Rent": "1 x Maandhuur",
      "2 x Monthly Rent": "2 x Maandhuur",
      "3 x Monthly Rent": "3 x Maandhuur",

      Included: "Inclusief",
      Excluded: "Exclusief",

      "Shower Cubicle": "Douchecabine",
      "Double Sinks": "Dubbele wasbak",
      "Walk-in Shower": "Inloopdouche",
      Jacuzzi: "Jacuzzi",
      Bathtub: "Bad",
      Sauna: "Sauna",
      Toilet: "Toilet",
      Washbasin: "Wasbak",

      Balcony: "Balkon",
      "Roof Terrace": "Dakterras",
      "French Balcony": "Frans balkon",
      Terrace: "Terras",
      Garden: "Tuin",
      "Not Applicable": "n.v.t.",

      "Public Parking": "Op straat parkeren",
      "Own Parking Spot": "Eigen parkeerplek",
      "Indoor Garage": "Garage",

      "TermsAndConditions": {
        "agreement": "Ik ga akkoord met de algemene voorwaarden, dat mijn gegevens worden verwerkt conform het privacybeleid en met de huurderseisen zoals vermeld in de woning advertentie.",
        "error": "Je moet akkoord gaan met de algemene voorwaarden."
      },
      "screening_profile": {
        "edit": "Bewerken",
        "edit_profile": "GoHome ID bewerken",
        "add_profile": "GoHome ID toevoegen",
        "save_changes": "Wijzigingen Opslaan",
        "change_employment_type_warning_title": "Werkgelegenheidstype wijzigen",
        "change_employment_type_warning_message": "Het wijzigen van het werkgelegenheidstype zal alle geüploade documenten verwijderen. Weet u zeker dat u door wilt gaan?",
        "firstname": "Voornaam",
        "lastname": "Achternaam",
        "surname": "Achternaam",
        "email": "E-mail",
        "phone": "Telefoon",
        "birthdate": "Geboortedatum",
        "birthplace": "Geboorteplaats",
        "province": "Provincie",
        "street": "Straat",
        "house_number": "Huisnummer + toevoeging",
        "postal_code": "Postcode",
        "city": "Plaats",
        "country": "Land",
        "income": "Maandinkomen in euro",
        "per_month": "per maand",
        "screening_type": "Type",
        "renter": "Huurder",
        "guarantor": "Garantsteller",
        "employment_type": "Inkomensbron",
        "employee": "Werknemer",
        "self_employed": "Zelfstandige",
        "pensioned": "Gepensioneerd",
        "documents": "Documenten",
        "doc_identity_front": "ID Voorzijde",
        "doc_identity_back": "ID Achterzijde",
        "doc_employer_declaration": "Werkgeversverklaring",
        "doc_bank_statement": "Bankafschrift",
        "doc_bankcard_copy": "Bankpas",
        "doc_payslip_1": "Overboeking salaris 1",
        "doc_payslip_2": "Overboeking salaris 2",
        "doc_payslip_3": "Overboeking salaris 3",
        "doc_employment_contract": "Arbeidsovereenkomst",
        "doc_tax_return": "Aangifte Inkomstenbelasting",
        "doc_company_registration": "KvK Uittreksel",
        "doc_income_statement": "Winst- en Verliesrekening",
        "doc_balance_statement": "Balans",
        "doc_aow_statement": "AOW Strook",
        "doc_pension_statement": "Pensioenoverzicht",
        "doc_landlord_declaration": "Verhuurdersverklaring",
        "doc_personal_record": "Uittreksel uit de BRP",
        "doc_uwv_record": "Uittreksel UWV",
        "selected_files": "Geselecteerde Bestanden",
        "doc_files": "Bestanden Uploaden",
        "required": "Verplicht",
        "view_document": "Document Bekijken",
        "document_uploaded": "Document Geüpload",
        "doc_document": "Document Uploaden",
        "uploading": "Bezig met uploaden",
        "identity_front_info": "Een duidelijke foto van de voorzijde van uw identiteitsbewijs",
        "identity_back_info": "Een duidelijke foto van de achterzijde van uw identiteitsbewijs",
        "employer_declaration_info": "Een werkgeversverklaring die niet ouder is dan 3 maanden",
        "bank_statement_info": "Een bankafschrift waarop bijschrijving van uw salaris van de afgelopen 3 maanden te zien is",
        "bank_card_info": "Een kopie van uw bankpas die overeenkomt met het bankafschrift",
        "payslip_1_info": "Uw laatst beschikbare overboeking salaris",
        "payslip_2_info": "Een overboeking salaris van maximaal 2 maanden oud",
        "payslip_3_info": "Een overboeking salaris van maximaal 3 maanden oud",
        "employment_contract_info": "Een kopie van uw getekende arbeidsovereenkomst",
        "tax_return_info": "Uw verzonden aangifte inkomstenbelasting voor het laatste jaar",
        "company_registration_info": "Een recent gewaarmerkt uittreksel van de Kamer van Koophandel",
        "income_statement_info": "Uw meest recente winst- en verliesrekening",
        "balance_statement_info": "Uw meest recente balans",
        "aow_statement_info": "Uw meest recente AOW (state pension) statement",
        "pension_statement_info": "Uw meest recente pensioenoverzicht",
        "landlord_declaration_info": "Een verklaring van jouw verhuurder waaruit blijkt dat er geen huurachterstand is en dat er nooit overlast is geweest",
        "personal_record_info": "Een gewaarmerkt uittreksel uit de Basisregistratie Personenregister",
        "uwv_record_info": "Een recent uittreksel van het UWV",
        "no_screening_profiles": "Nog geen GoHome ID's",
        "delete_confirm_title": "GoHome ID Verwijderen",
        "delete_confirm_description": "Weet u zeker dat u dit profiel wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
        "section_title": "Huurders en garantstellers",
        "section_description": "Voeg hier alle personen toe die het huurcontract gaan ondertekenen. Als je een garantsteller nodig hebt (bijvoorbeeld omdat je inkomen niet hoog genoeg is), kun je die hier ook toevoegen.",
        "main_renter_info": "De hoofdhuurder is de eerste persoon die het contract ondertekent. Je kunt de volgorde van de huurders aanpassen door op 'Maak hoofdhuurder' te klikken.",
        "guarantor_info": "Een garantsteller is iemand die garant staat voor de huur als de huurder niet kan betalen. Dit is vaak nodig als het inkomen niet hoog genoeg is of als er geen vast contract is.",
        "what_is_this": "Wat is GoHome ID?",
        "description": "GoHome ID's zijn herbruikbare sjablonen die uw persoonlijke en financiële gegevens opslaan. Maak en beheer uw GoHome ID om snel op meerdere woningen te kunnen reageren zonder telkens opnieuw uw gegevens in te voeren.",
        "benefit_1": "Bespaar tijd door uw geverifieerde informatie te hergebruiken bij meerdere woningaanvragen",
        "benefit_2": "Houd uw screeninginformatie op één plek up-to-date",
        "benefit_3": "Stroomlijn het aanvraagproces voor toekomstige screenings",
        "create_modal": {
          "title": "GoHome ID Aanmaken",
          "type": "Type",
          "first_name": "Voornaam",
          "last_name": "Achternaam",
          "error_required": "Vul zowel voornaam als achternaam in",
          "error_failed": "GoHome ID aanmaken mislukt",
          "cancel": "Annuleren",
          "create": "GoHome ID Aanmaken"
        }
      },

      common: {
        back: "Terug",
        confirm: "Bevestigen",
        cancel: "Annuleren"
      },

      datakeeper: {
        "success": "We hebben je screeninggegevens ontvangen! We nemen contact met je op zodra we je gegevens hebben verwerkt.",
      },

      "screening.title": "Screening",
      "screening.not_logged_in": "U bent niet ingelogd, log in om uw screening in te vullen.",
      "screening.go_to_login": "Ga naar login",
      "screening.not_found": "Geen screening gevonden",
      "screening.not_found_description": "Er is geen screening gevonden. Ga naar de aanmeldingenpagina om al uw screenings te bekijken.",
      "screening.go_to_applications": "Ga naar aanmeldingen",

      "screening.general_info.title": "Informatie over jou en mede huurders",
      "screening.general_info.motivation": "Motivatie",
      "screening.general_info.monthly_income": "Maandelijks verzamelinkomen in euro",
      "screening.general_info.monthly_income_help": "Maandelijkse bruto verzamelinkomen in euro van alle personen die het contract tekenen.",
      "screening.general_info.viewing_type": "Hoe heb jij bezichtigd?",
      "screening.general_info.viewing_rating": "Hoe beoordeel je onze collega die jou heeft geholpen tijdens de bezichtiging?",
      "screening.general_info.rental_period": "Hoe lang wil jij de woning huren?",
      "screening.general_info.rental_date": "Per wanneer kun je de woning huren? (datum)",
      "screening.general_info.rental_date_explanation": "Beschrijf hoe lang jij de woning verwacht te huren",
      "screening.general_info.composition": "Samenstelling",
      "screening.general_info.adults": "Volwassenen",
      "screening.general_info.kids": "Kinderen",
      "screening.general_info.pets": "Heb je huisdieren?",
      "screening.general_info.pets_details": "Welke huisdieren heb je?",
      "screening.profile_management.add_profile": "Huurder of garantsteller toevoegen",
      "screening.profile_management.section_title": "Huurders en garantstellers",
      "screening.profile_management.section_description": "Voeg hier alle personen toe die het huurcontract gaan ondertekenen. Als je een garantsteller nodig hebt (bijvoorbeeld omdat je inkomen niet hoog genoeg is), kun je die hier ook toevoegen.",
      "screening.profile_management.main_renter_info": "De hoofdhuurder is de eerste persoon die het contract ondertekent. Je kunt de volgorde van de huurders aanpassen door op 'Maak hoofdhuurder' te klikken.",
      "screening.profile_management.guarantor_info": "Een garantsteller is iemand die garant staat voor de huur als de huurder niet kan betalen. Dit is vaak nodig als het inkomen niet hoog genoeg is of als er geen vast contract is.",
      "screening.profile_management.remove_profile": "Verwijder uit screening",
      "screening.profile_management.remove_profile_confirm_title": "GoHome ID verwijderen uit screening",
      "screening.profile_management.remove_profile_confirm_description": "Weet je zeker dat je dit GoHome ID wilt verwijderen uit de screening? Dit profiel blijft wel bestaan in je account, maar wordt niet meer gebruikt voor deze screening.",
      "screening.profile_management.remove_profile_confirm": "Verwijderen",
      "screening.profile_management.cancel": "Annuleren",
      "screening.profile_management.no_profiles": "Geen huurder toegevoegd",
      "screening.profile_management.no_profiles_description": "Voeg minimaal één huurder toe aan je screening om door te kunnen gaan",

      "screening.header.title": "Screening",
      "screening.header.description": "Vul onderstaand formulier zo volledig en correct mogelijk in voor iedereen in jouw huishouden. Wij gebruiken deze informatie om te beoordelen of je in aanmerking komt voor deze woning. Dit doen wij conform de wet- en regelgeving van de Algemene Verordening Gegevensbescherming (AVG).",
      "screening.header.check_info": "Controleer na het invullen van het formulier goed of alle gegevens kloppen, voordat je het formulier verzend. Na verzenden van het formulier ontvangt iedereen binnen jouw huishouden een bevestiging van de aangeleverde gegevens. Klopt er iets niet? Neem dan contact op via support@gohome.rent",
      "screening.header.per_month": "/ mnd",

      "screening.review.terms_error": "Je moet akkoord gaan met de algemene voorwaarden.",
      "screening.review.terms_text": "Ik ga akkoord met de algemene voorwaarden, dat mijn gegevens worden verwerkt conform het privacybeleid en met de huurderseisen zoals vermeld in de woning advertentie.",
      "screening.review.terms_link": "algemene voorwaarden",
      "screening.review.submit": "Screening indienen",

      "screening.review.general_info": "Algemene informatie",
      "screening.review.motivation": "Motivatie",
      "screening.review.rental_period_desc": "Beschrijving huurperiode",
      "screening.review.rental_date": "Huurdatum",
      "screening.review.rental_period": "Huurperiode",
      "screening.review.shared_income": "Gezamenlijk inkomen",
      "screening.review.adults": "Volwassenen",
      "screening.review.pets": "Huisdieren",
      "screening.review.viewed": "Bezichtigd",
      "screening.review.signers": "Aantal ondertekenaars",
      "screening.review.kids": "Kinderen",
      "screening.review.empty_field": "Leeg Veld",
      "screening.review.yes": "Ja",
      "screening.review.no": "Nee",
      "screening.review.renter_required": "Er moet minimaal één huurder aan de screening worden toegevoegd",
      "screening.review.renter_required_title": "Huurder vereist",

      "screening.review_viewing.what_good": "Wat vond je erg goed?",
      "screening.review_viewing.what_bad": "Wat vond je minder goed?",
      "screening.review_viewing.rating_explanation": "Geef een korte toelichting op jouw beoordeling",
      "screening.review_viewing.rating_explanation_optional": "Geef een korte toelichting op jouw beoordeling (optioneel)",
      "screening.review_viewing.rating": "Beoordeling",
      "screening.dropdowns.viewing_options.on_location": "Op locatie bij de woning",
      "screening.dropdowns.viewing_options.video": "Via de woning video",
      "screening.dropdowns.viewing_options.both": "Allebei",
      "screening.dropdowns.rental_period.6_months": "6 maanden",
      "screening.dropdowns.rental_period.1_year": "1 jaar",
      "screening.dropdowns.rental_period.1_5_years": "1,5 jaar",
      "screening.dropdowns.rental_period.2_years": "2 jaar",
      "screening.dropdowns.rental_period.more_than_2_years": "Langer dan 2 jaar",
      "screening.dropdowns.rental_period.other": "Overig",
      "screening.dropdowns.employment.employee": "Loondienst",
      "screening.dropdowns.employment.self_employed": "Zelfstandig ondernemer",
      "screening.dropdowns.employment.pension": "Pensioen",
      "screening.dropdowns.pets.yes": "Ja",
      "screening.dropdowns.pets.no": "Nee",
      "screening.dropdowns.guarantor.yes": "Ja",
      "screening.dropdowns.guarantor.no": "Nee",
      
      "screening_profile.redact_document": "Document redigeren",
      // Image Redactor translations
      "imageRedactor.guide.description": "Gebruik <strong>Redigeren</strong> om gevoelige gegevens te bedekken. Je kunt de <strong>Laatste</strong> box ongedaan maken of <strong>Alles</strong> herstellen.",
      "imageRedactor.guide.recommended": "Verplicht te redigeren:",
      
      // Identity Back specific
      "imageRedactor.guide.back.bsn": "BSN (Burgerservicenummer)",
      "imageRedactor.guide.back.mrz": "MRZ (Machine leesbare zone - onderste regels)",
      "imageRedactor.guide.back.docNumber": "Documentnummer (indien aanwezig)",
      "imageRedactor.guide.back.optional": "Optionele velden die niet nodig zijn voor identificatie",
      
      // Identity Front specific
      "imageRedactor.guide.front.bsn": "BSN",
      "imageRedactor.guide.front.docNumber": "Documentnummer",
      "imageRedactor.guide.front.signature": "Handtekening",
      "imageRedactor.guide.front.photo": "Foto",
      
      "imageRedactor.guide.warning": "Let op! het niet correct redigeren van het document kan leiden tot een afwijzing van de aanvraag.",
      
      // Buttons and actions
      "imageRedactor.button.redact": "Redigeren",
      "imageRedactor.button.undo": "Undo",
      "imageRedactor.button.watermark": "Watermerk",
      "imageRedactor.button.reset": "Opnieuw",
      "imageRedactor.button.save": "Opslaan",
    },
  },
  en: {
    translation: {
      "nav.property_listing": "Property listing",
      "nav.rent": "Rent",
      "nav.rent_out": "Rent out",

      "profile.profile": "Profile",
      "profile.applications": "Applications",
      "profile.logout": "Logout",
      "profile.repairrequest": "Repair request",
      "profile.landlord-statement": "Landlord statement",
      "profile.lease-termination": "Lease termination",
      "profile.screening_profile": "GoHome ID",

      "profile.name": "Name",
      "profile.firstname": "First name",
      "profile.surname": "Last name",
      "profile.phone": "Phone number",
      "profile.dateofbirth": "Date of birth",
      "profile.shared_income": "Shared income",
      "profile.email": "Email",
      "profile.upgrade_button": "Upgrade to premium",
      "profile.upgrade": "Upgrade to premium",
      "profile.edit_profile": "Edit profile",
      "profile.basic_account": "Basic account",
      "profile.premium_account": "Premium account",
      "profile.basic_price": "Free",
      "profile.unlimited": "Unlimited",
      "profile.feature1":
        "Always receive an invitation to the viewing 1 hour earlier and be the first to view a property.",
      "profile.feature2": "Direct access to available listings",
      "profile.signup": "Register",
      "profile.annualy": "one time",
      "profile.title": "Sign up as a tenant",
      "profile.create_landlord_account": "Create landlord account",
      "profile.most_chosen": "Popular",
      "profile.back": "Back to overview",
      "profile.your_details": "Your details",
      "profile.contact": "Contact",
      "profile.address": "Address",
      "profile.province": "Province",
      "screening_profile.missing_information": "Missing information",
      "screening_profile.renter_number": "Tenant {{number}}",
      "screening_profile.guarantor_number": "Guarantor {{number}}",
      "screening_profile.main_renter": "Main tenant",
      "screening_profile.incomplete": "Incomplete",
      "screening_profile.make_main_renter": "Make main tenant",
      "screening_profile.firstname": "First name",
      "screening_profile.surname": "Last name",
      "screening_profile.email": "Email",
      "screening_profile.phone": "Phone number",
      "screening_profile.birthdate": "Date of birth",
      "screening_profile.birthplace": "Place of birth",
      "screening_profile.street": "Street",
      "screening_profile.house_number": "House number",
      "screening_profile.postal_code": "Postal code",
      "screening_profile.city": "City",
      "screening_profile.country": "Country",
      "screening_profile.province": "Province",
      "screening_profile.income": "Income",
      "screening_profile.employment_type": "Employment type",
      "screening_profile.screening_type": "Screening type",

      "createAccount.firstname": "First name",
      "createAccount.lastName": "Last name",
      "createAccount.email": "Email",
      "createAccount.phone": "Phone number",
      "createAccount.password": "Password",
      "createAccount.confirm_password": "Confirm password",
      "createAccount.terms1": "I agree to the",
      "createAccount.terms2": "terms and conditions",
      "createAccount.createAccount": "Create account",
      "createAccount.how_it_works": "How does it work?",
      "createAccount.account": "Account",
      "createAccount.account.text":
        "Easily create an account and take the first steps towards your new rental home. Schedule a viewing right away or register as an interested party.",
      "createAccount.planning": "Planning",
      "createAccount.planning.text":
        "You've seen a beautiful rental home and would like to view it. Through our platform, you can schedule a viewing within the available time slots.",
      "createAccount.viewing": "Viewing",
      "createAccount.viewing.text":
        "One of our viewers will guide the viewing so that you get an optimal impression of the home. Can't be there physically? No problem! We'll send you a video.",
      "createAccount.register": "Register",
      "createAccount.register.text":
        "After the viewing, you'll receive an invitation to complete your registration. We'll start the screening process to thoroughly assess whether you qualify for the home.",
      "createAccount.contract": "Contract",
      "createAccount.contract.text":
        "Has the home been assigned to you? Congratulations! The rental agreement will be drawn up immediately and signed online. This way everything is quickly arranged and you're ready to move.",
      "createAccount.checkin": "Key Handover",
      "createAccount.checkin.text":
        "After signing, we'll plan a moment for the key handover. We'll digitally record the condition of the home in an inspection report and hand over the keys to you. Let's GoHome!",

      "signin.login_as_landlord": "Log in as landlord",
      "signin.email": "Email",
      "signin.password": "Password",
      "signin.forgot_password": "Forgot password",
      "signin.login": "Log in",
      "signin.create_account": "Create account",
      "signin.or": "or",
      "signin.remember_me": "Remember me",

      "createdProfile.premium.text":
        "Thank you for signing up as a Premium tenant! We look forward to helping you in your search for a new home. We have sent you an email to verify your account. This may take a few minutes.",
      "createdProfile.basic.text":
        "We look forward to helping you in your search for a new home. We have sent you an email to verify your account.<br><br>This may take a few minutes.",

      "verified.title": "Your account is activated!",
      "verified.subtitle":
        "Start your search for your new home right away. Through your personal tenant dashboard, you always have insight into the status of the properties in your selection.",
      "verified.list-title": "Start your search like this:",
      "verified.list-item1": "Express your interest",
      "verified.list-item2":
        "Sign up for a physical viewing or a Propertyvideo",
      "verified.list-item3":
        "Complete your tenant profile through the screening",
      "verified.questions":
        "If you have any questions or need help using your account, please contact us at support@gohome.rent. Our team is ready to assist you!",

      "profile.view_property": "View property",
      "profile.to_screening": "Fill out screening",
      "profile.view_screening": "View screening",

      "overview.recently_rented": "Recently rented",
      "overview.available_from": "Available from",
      "overview.directly_available": "Directly available",
      "overview.available_soon": "Available soon",
      "overview.apply_filter": "Apply filter",
      "overview.reset": "Reset",
      "overview.rooms": "Rooms",
      "overview.price": "Price",
      "overview.location": "Location",
      "overview.city": "City",
      "overview.sort_by": "Sort by",
      "overview.minimum": "Minimum",
      "overview.maximum": "Maximum",
      "overview.result": "Result",
      "overview.results": "Results",
      "overview.map": "Map",
      "overview.list": "List",
      "overview.tab_properties": "Properties",
      "overview.tab_collections": "Complexes",

      "complex.sidebar.title": "Complex overview",
      "complex.sidebar.availableProperties1": "Of the",
      "complex.sidebar.availableProperties2": "houses in this project",
      "complex.sidebar.availableProperties3": "are still available",
      "complex.types.availableApartments": "Apartments available",
      "complex.card.available": "available",
      "complex.card.of": "of",

      "details.read_more": "Read more",
      "details.read_less": "Read less",
      "details.subscribe_video": "Subscribe to Propertyvideo",
      "details.attending_video": "Subscribed to Propertyvideo",

      "select.date_desc": "Date added - descending",
      "select.price_asc": "Price - ascending",
      "select.price_desc": "Price - descending",

      "details.deposit": "Deposit",
      "details.furnished": "Upholstered",
      "details.description": "Description",
      "details.all_photos": "View all photos",
      "details.landlord": "Landlord",
      "details.apartment": "Apartment",
      "details.rental_conditions": "Rental conditions",
      "details.bedrooms": "bedroom",
      "details.bathrooms": "bathroom",
      "details.furnishedDecorated": "Furnished",

      "viewing.subscribeText_interested":
        "Thank you for your interest in this property. You will be notified when a viewing is scheduled.",
      "viewing.subscribeText_default":
        "There is currently no viewing scheduled for this property. Sign up to receive a notification when a viewing is available.",
      "viewing.plan_viewing": "Plan viewing",
      "viewing.recently_rented": "This property has recently been rented.",
      "viewing.show_interest": "Show interest",
      "viewing.subscribed": "Subscribed",
      "viewing.login_or_create_account":
        "Log in or create a (free) account to plan a viewing.",
      "viewing.createAccount": "Create account",
      "viewing.or": "or",
      "viewing.all-events-booked": "All events are booked",
      "viewing.video_viewing": "Property video",
      "viewing.upgradeAccount-title": "Get benefits",
      "viewing.upgradeAccount-text":
        "For many of the homes on offer, there is more interest than available viewing spots. With a premium account, you get to claim your spot an hour earlier and many other benefits.",
      "viewing.upgradeAccount-button": "Upgrade to premium",

      "book-viewing.title":
        "Interested in this property? Sign up for a viewing and discover the possibilities.",
      "book-viewing.loading": "Registration is being processed",

      "viewing.video_viewing.text":
        "We also create a property video. Request it, and we will send it to you by email as soon as it is available.",

      "timeslots.unsubscribe": "Unsubscribe",
      "timeslots.openDialog.text":
        "Do you want to unsubscribe from this viewing?",
      "timeslots.handleBookTimeslot.title": "Book viewing",
      "timeslots.handleBookTimeslot.text":
        "Are you sure you want to book this viewing from",
      "timeslots.handleBookTimeslot.to": "to",
      "timeslots.available-timeslots": "spots available",

      "accountform.error.fields": "All fields must be filled out.",
      "accountform.error.invalidPassword":
        "The password must be at least 8 characters long, contain at least one digit, one uppercase letter, one lowercase letter, and one special character.",
      "accountform.error.passwordsDontMatch": "Passwords do not match.",
      "accountform.error.terms":
        "To create an account, the terms and conditions must be accepted.",

      "dates.month": "Month",
      "dates.year": "Year",

      "applications.none": "No applications yet",

      "phase.interested": "Interested",
      "phase.interested.text":
        "Thank you for your interest.<br/><br/>We will schedule a viewing soon. Once the viewing is scheduled, you will be notified and can sign up for a timeslot.<br/><br/>If you can no longer sign up for a timeslot, you can request a Propertyvideo.",

      "phase.viewing": "Viewing",
      "phase.viewing.text":
        "You are signed up for the viewing.<br/><br/>Make sure you are on time for your viewing and wait for our viewer to let you in.",

      "phase.videoviewing": "Property video",
      "phase.videoviewing.text":
        "You are signed up for the (video) viewing.<br/><br/>The video will be automatically sent to your email once it is available.",

      "phase.assigned": "Property assigned",
      "phase.assigned.text":
        "The landlord has chosen you as the new tenant.<br/><br/>We will contact you soon to review the rental conditions, after which you can officially accept the property.",

      "phase.screening_invited": "Invited for screening",
      "phase.screening_invited.text":
        "You can now fill out your screening form.<br/><br/>Please do this as soon as possible so we can determine if you qualify for the property. If you do not have all the documents available yet, you can close the screening form and reopen it later.<br/><br/>Changes will be saved in the meantime.",
      
      "phase.screening": "Screening",
      "phase.screening.text":
        "Thank you for submitting all your details, we are processing the screening.<br/><br/>The screening process takes an average of 10 working days. We will contact you if we need more information.",
      
      "phase.datakeeper_invited": "Invited for Datakeeper",
      "phase.datakeeper_invited.text":
        "Every tenant and guarantor entered in the screening has received an email with an invitation to share their information with GoHome via Datakeeper.",

      "phase.datakeeper_completed": "Datakeeper completed",
      "phase.datakeeper_completed.text":
        "Thank you for submitting all your information. We are currently processing Datakeeper.<br/><br/>The screening process takes an average of 10 working days. We will contact you if we need more information.",

      "phase.contract": "Contract",
      "phase.contract.text":
        "The contract is being prepared.<br/><br/>Once the contract is ready, you will receive a DocuSign request by email to sign your rental agreement digitally.",
  
      "phase.checkin": "Key handover",
      "phase.checkin.text":
        "The contract is signed, congratulations!<br/><br/>We will contact you shortly to schedule the key handover.",

      "phase.rented": "Rented",
      "phase.rented.text": "We wish you a great time living here!",

      "footer.work_at": "Work at GoHome?",
      "footer.about": "About us",
      "footer.jobs": "Jobs",
      "footer.knowledge_base": "Knowledge center",
      "footer.faq": "Frequently asked questions",
      "footer.conditions": "Terms and conditions",
      "footer.privacy": "Privacy policy",

      "specifications.living_area": "Living area",
      "specifications.plot_area": "Plot area",
      "specifications.floors": "Number of floors",
      "specifications.rooms": "Number of rooms",
      "specifications.bedrooms": "Number of bedrooms",
      "specifications.bathrooms": "Number of bathrooms",
      "specifications.bathroom_amenities": "Bathroom amenities",
      "specifications.toilet": "Separate toilet",
      "specifications.outdoor_space": "Outdoor space",
      "specifications.garage": "Garage",
      "specifications.shed": "Shed/storage",
      "specifications.parking": "Parking",
      "specifications.construction": "Type of construction",
      "specifications.date_available": "Available from",
      "specifications.rental_period": "Rental period",
      "specifications.deposit": "Deposit",
      "specifications.service_charge": "Service costs",
      "specifications.heating_cost": "Heating costs",
      "specifications.tv_internet": "Television and internet",
      "specifications.furnished_decorated": "Upholstered",
      "specifications.furniture": "Furnished",
      "specifications.sharing": "House sharing",
      "specifications.pets": "Pets",
      "specifications.smoking": "Smoking",
      "specifications.energy_label": "Energy label",

      "rentalperiod.fixed": "Fixed term",
      "rentalperiod.indefinite": "Indefinite term",
      "rentalperiod.with_option": "Fixed term with option for indefinite term",

      "screening.document.identiteitsbewijs_-_voorkant":
        "One of the following documents with a valid expiration date: Driver's License (NL), ID Card (International), Passport (International).",
      "screening.document.identiteitsbewijs_-_achterkant":
        "One of the following documents with a valid expiration date: Driver's License (NL), ID Card (International), Passport (International).",
      "screening.document.recente_werkgeversverklaring":
        "An employer statement that is no older than 3 months. Ensure that all information is fully completed by your employer.",
      "screening.document.bankafschrift":
        "A bank statement showing salary deposits from the last 3 months.",
      "screening.document.kopie_bankpas":
        "A copy of your bank card that matches the bank statement.",
      "screening.document.loonstrook_1":
        "Your most recent available payslip.",
      "screening.document.loonstrook_2":
        "A payslip that is no older than 2 months.",
      "screening.document.loonstrook_3":
        "A payslip that is no older than 3 months.",
      "screening.document.kopie_arbeidsovereenkomst":
        "A copy of your signed employment contract if you have a new job.",
      "screening.document.aangifte_inkomstenbelasting":
        "Your submitted income tax return for the year 2023.",
      "screening.document.verhuurdersverklaring":
        "A statement from your landlord confirming that there are no rental arrears and that no disturbances have occurred. If your landlord is unavailable, upload a bank statement showing rent payments for the last 6 months.",
      "screening.document.uittreksel_brp":
        "An official extract from the Personal Records Database. You can request this from your municipality.",
      "screening.document.uittreksel_uwv":
        "A recent extract from the UWV.",
      "screening.document.kvk_uittreksel":
        "A recent official extract from the Chamber of Commerce.",
      "screening.document.ib60_formulier":
        "Your most recent IB60 form. You can request this from the tax authorities.",
      "screening.document.balans_winstverliesrekening":
        "Your most recent profit and loss statement and balance sheet for the past 3 years.",
      "screening.document.recente_aow-strook":
        "Your most recent AOW (state pension) statement.",

      "datakeeper.intro":
        "To securely retrieve your data, we use Datakeeper. This is only available for users with DigiD. Please select the option that applies:",
      "datakeeper.qrcode":
        "Scanning the QR code will redirect you to Datakeeper. Retrieving your data could take a couple of minutes. The page will automatically update when the process is done.",
      "datakeeper.digid.yes": "I have DigiD",
      "datakeeper.digid.no": "I don't have DigiD",
      "datakeeper.noDigid1":
        "If you don't have DigiD, we cannot confirm your data with datakeeper.",
      "datakeeper.noDigid2": "This might result in a longer processing time.",
      "datakeeper.title": "Screening for",
      "datakeeper.completed":
        "We recieved your screening data! We will contact you when we processed your details.",

      Yes: "Yes",
      No: "No",

      Allowed: "Allowed",
      "Not Allowed": "Not allowed",

      Apartment: "Apartment",
      Studio: "Studio",
      House: "House",
      Storage: "Storage",

      "No energy label": "No energy label",

      "Existing Building": "Existing building",
      "New Construction": "New construction",

      "1.5 x Monthly Rent": "1.5 x monthly rent",
      "1 x Monthly Rent": "1 x monthly rent",
      "2 x Monthly Rent": "2 x monthly rent",
      "3 x Monthly Rent": "3 x monthly rent",

      Included: "Included",
      Excluded: "Excluded",

      "Shower Cubicle": "Shower cubicle",
      "Double Sinks": "Double sinks",
      "Walk-in Shower": "Walk-in shower",
      Jacuzzi: "Jacuzzi",
      Bathtub: "Bathtub",
      Sauna: "Sauna",
      Toilet: "Toilet",
      Washbasin: "Washbasin",

      Balcony: "Balcony",
      "Roof Terrace": "Roof terrace",
      "French Balcony": "French balcony",
      Terrace: "Terrace",
      Garden: "Garden",
      "Not Applicable": "N/A",

      "Public Parking": "Public parking",
      "Own Parking Spot": "Own parking spot",
      "Indoor Garage": "Indoor garage",

      "TermsAndConditions": {
        "agreement": "I agree to the terms and conditions, that my data will be processed in accordance with the privacy policy and with the tenant requirements as stated in the property listing.",
        "error": "You must agree to the terms and conditions."
      },
      "screening_profile": {
        "edit": "Edit",
        "edit_profile": "Edit GoHome ID",
        "add_profile": "Add GoHome ID",
        "save_changes": "Save Changes",
        "change_employment_type_warning_title": "Change Employment Type",
        "change_employment_type_warning_message": "Changing the employment type will remove all uploaded documents. Are you sure you want to continue?",
        "firstname": "First Name",
        "lastname": "Last Name",
        "surname": "Last Name",
        "email": "Email",
        "phone": "Phone",
        "birthdate": "Birth Date",
        "birthplace": "Birth Place",
        "province": "Province",
        "street": "Street",
        "house_number": "House Number + Addition",
        "postal_code": "Postal Code",
        "city": "City",
        "country": "Country",
        "income": "Income",
        "per_month": "per month",
        "screening_type": "Type",
        "renter": "Renter",
        "guarantor": "Guarantor",
        "employment_type": "Source of income",
        "employee": "Employee",
        "self_employed": "Self-employed",
        "pensioned": "Pensioned",
        "documents": "Documents",
        "doc_identity_front": "ID Front",
        "doc_identity_back": "ID Back",
        "doc_employer_declaration": "Employer Declaration",
        "doc_bank_statement": "Bank Statement",
        "doc_bankcard_copy": "Bank Card",
        "doc_payslip_1": "Payslip 1",
        "doc_payslip_2": "Payslip 2",
        "doc_payslip_3": "Payslip 3",
        "doc_employment_contract": "Employment Contract",
        "doc_tax_return": "Tax Return",
        "doc_company_registration": "Company Registration",
        "doc_income_statement": "Income Statement",
        "doc_balance_statement": "Balance Statement",
        "doc_aow_statement": "AOW Statement",
        "doc_pension_statement": "Pension Statement",
        "doc_landlord_declaration": "Landlord Declaration",
        "doc_personal_record": "Personal Record",
        "doc_uwv_record": "UWV Record",
        "selected_files": "Selected Files",
        "doc_files": "Files",
        "required": "Required",
        "view_document": "View Document",
        "document_uploaded": "Document Uploaded",
        "doc_document": "Document",
        "uploading": "Uploading",
        "identity_front_info": "a clear photo of the front of your ID document",
        "identity_back_info": "a clear photo of the back of your ID document",
        "employer_declaration_info": "an employer declaration that is no older than 3 months",
        "bank_statement_info": "a bank statement showing salary deposits from the last 3 months",
        "bank_card_info": "a copy of your bank card that matches the bank statement",
        "payslip_1_info": "your most recent available payslip",
        "payslip_2_info": "a payslip that is no older than 2 months",
        "payslip_3_info": "a payslip that is no older than 3 months",
        "employment_contract_info": "a copy of your signed employment contract",
        "tax_return_info": "your submitted income tax return for the last year",
        "company_registration_info": "a recent official extract from the Chamber of Commerce",
        "income_statement_info": "your most recent profit and loss statement",
        "balance_statement_info": "your most recent balance sheet",
        "aow_statement_info": "your most recent AOW (state pension) statement",
        "pension_statement_info": "your most recent pension statement",
        "landlord_declaration_info": "a statement from your landlord confirming no rental arrears and no disturbances",
        "personal_record_info": "an official extract from the Personal Records Database",
        "uwv_record_info": "a recent extract from the UWV",
        "no_screening_profiles": "No GoHome ID's yet",
        "delete_confirm_title": "Delete GoHome ID",
        "delete_confirm_description": "Are you sure you want to delete this GoHome ID? This action cannot be undone.",
        "section_title": "Renters and Guarantors",
        "section_description": "Add all persons who will sign the rental contract here. If you need a guarantor (for example, because your income is not high enough), you can add them here as well.",
        "main_renter_info": "The main renter is the first person to sign the contract. You can change the order of renters by clicking 'Make main renter'.",
        "guarantor_info": "A guarantor is someone who guarantees the rent if the renter cannot pay. This is often required if the income is not high enough or if there is no permanent contract.",
        "what_is_this": "What is GoHome ID?",
        "description": "GoHome ID's are reusable templates that store your personal and financial information. Create and manage your GoHome ID to quickly apply for multiple properties without having to re-enter your details each time.",
        "benefit_1": "Save time by reusing your verified information across multiple property applications",
        "benefit_2": "Keep your screening information up-to-date in one place",
        "benefit_3": "Streamline the application process for future property screenings",
        "create_modal": {
          "title": "Create GoHome ID",
          "type": "Type",
          "first_name": "First Name",
          "last_name": "Last Name",
          "error_required": "Please enter both first and last name",
          "error_failed": "Failed to create GoHome ID",
          "cancel": "Cancel",
          "create": "Create GoHome ID"
        }
      },

      common: {
        back: "Back",
        confirm: "Confirm",
        cancel: "Cancel"
      },

      datakeeper: {
        "success": "We have received your screening data! We will contact you when we processed your details.",
      },

      "screening.title": "Screening",
      "screening.not_logged_in": "You are not logged in, please log in to complete your screening.",
      "screening.go_to_login": "Go to login",
      "screening.not_found": "No screening found",
      "screening.not_found_description": "No screening was found. Go to the applications page to view all your screenings.",
      "screening.go_to_applications": "Go to applications",

      "screening.general_info.title": "Information about you and co-tenants",
      "screening.general_info.motivation": "Motivation",
      "screening.general_info.monthly_income": "Monthly combined income in euros",
      "screening.general_info.monthly_income_help": "Monthly gross combined income in euros of all persons signing the contract.",
      "screening.general_info.viewing_type": "How did you view the property?",
      "screening.general_info.viewing_rating": "How do you rate our colleague who helped you during the viewing?",
      "screening.general_info.rental_period": "How long do you want to rent the property?",
      "screening.general_info.rental_date": "From when can you rent the property? (date)",
      "screening.general_info.rental_date_explanation": "Describe how long you expect to rent the property",
      "screening.general_info.composition": "Composition",
      "screening.general_info.adults": "Adults",
      "screening.general_info.kids": "Children",
      "screening.general_info.pets": "Do you have pets?",
      "screening.general_info.pets_details": "Which pets do you have?",
      "screening.profile_management.add_profile": "Add renter or guarantor",
      "screening.profile_management.section_title": "Renters and Guarantors",
      "screening.profile_management.section_description": "Add all persons who will sign the rental contract here. If you need a guarantor (for example, because your income is not high enough), you can add them here as well.",
      "screening.profile_management.main_renter_info": "The main renter is the first person to sign the contract. You can change the order of renters by clicking 'Make main renter'.",
      "screening.profile_management.guarantor_info": "A guarantor is someone who guarantees the rent if the renter cannot pay. This is often required if the income is not high enough or if there is no permanent contract.",
      "screening.profile_management.remove_profile": "Remove from screening",
      "screening.profile_management.remove_profile_confirm_title": "Remove profile from screening",
      "screening.profile_management.remove_profile_confirm_description": "Are you sure you want to remove this profile from the screening? This profile will still exist in your account but won't be used for this screening anymore.",
      "screening.profile_management.remove_profile_confirm": "Remove",
      "screening.profile_management.cancel": "Cancel",
      "screening.profile_management.no_profiles": "No renter added",
      "screening.profile_management.no_profiles_description": "Add at least one renter to your screening to continue",

      "screening.header.title": "Screening",
      "screening.header.description": "Please fill out the form below as completely and accurately as possible for everyone in your household. We use this information to assess whether you qualify for this property. We do this in accordance with the General Data Protection Regulation (GDPR).",
      "screening.header.check_info": "After filling out the form, please check carefully if all information is correct before submitting. After submission, everyone in your household will receive a confirmation of the provided information. If something is incorrect? Please contact us at support@gohome.rent",
      "screening.header.per_month": "/ month",

      "screening.review.terms_error": "You must agree to the terms and conditions.",
      "screening.review.terms_text": "I agree to the terms and conditions, that my data will be processed in accordance with the privacy policy and with the tenant requirements as stated in the property advertisement.",
      "screening.review.terms_link": "terms and conditions",
      "screening.review.submit": "Submit Screening",

      "screening.review.general_info": "General Information",
      "screening.review.motivation": "Motivation",
      "screening.review.rental_period_desc": "Rental Period Description",
      "screening.review.rental_date": "Rental Date",
      "screening.review.rental_period": "Rental Period",
      "screening.review.shared_income": "Combined Income",
      "screening.review.adults": "Adults",
      "screening.review.pets": "Pets",
      "screening.review.viewed": "Viewed",
      "screening.review.signers": "Number of Signers",
      "screening.review.kids": "Children",
      "screening.review.empty_field": "Empty Field",
      "screening.review.yes": "Yes",
      "screening.review.no": "No",
      "screening.review.renter_required": "At least one renter must be added to the screening",
      "screening.review.renter_required_title": "Renter Required",

      "screening.review_viewing.what_good": "What did you like?",
      "screening.review_viewing.what_bad": "What could be improved?",
      "screening.review_viewing.rating_explanation": "Please provide a brief explanation of your rating",
      "screening.review_viewing.rating_explanation_optional": "Please provide a brief explanation of your rating (optional)",
      "screening.review_viewing.rating": "Rating",
      "screening.dropdowns.viewing_options.on_location": "At the property location",
      "screening.dropdowns.viewing_options.video": "Via property video",
      "screening.dropdowns.viewing_options.both": "Both",
      "screening.dropdowns.rental_period.6_months": "6 months",
      "screening.dropdowns.rental_period.1_year": "1 year",
      "screening.dropdowns.rental_period.1_5_years": "1.5 years",
      "screening.dropdowns.rental_period.2_years": "2 years",
      "screening.dropdowns.rental_period.more_than_2_years": "More than 2 years",
      "screening.dropdowns.rental_period.other": "Other",
      "screening.dropdowns.employment.employee": "Employee",
      "screening.dropdowns.employment.self_employed": "Self-employed",
      "screening.dropdowns.employment.pension": "Pension",
      "screening.dropdowns.pets.yes": "Yes",
      "screening.dropdowns.pets.no": "No",
      "screening.dropdowns.guarantor.yes": "Yes",
      "screening.dropdowns.guarantor.no": "No",

      "screening_profile.redact_document": "Redact document",
      // Image Redactor translations
      "imageRedactor.guide.title": "Redaction Guide",
      "imageRedactor.guide.description": "Use <strong>Redact</strong> to cover sensitive data. You can <strong>Undo</strong> the last placed box or <strong>Revert</strong> all.",
      "imageRedactor.guide.recommended": "Mandatory to redact:",
      
      // Identity Back specific
      "imageRedactor.guide.back.bsn": "BSN (Burgerservicenummer)",
      "imageRedactor.guide.back.mrz": "MRZ (Machine Readable Zone - bottom lines)",
      "imageRedactor.guide.back.docNumber": "Document Number (if present)",
      "imageRedactor.guide.back.optional": "Optional fields not required for identification",
      
      // Identity Front specific
      "imageRedactor.guide.front.bsn": "BSN (Burgerservicenummer)",
      "imageRedactor.guide.front.docNumber": "Doc. Number",
      "imageRedactor.guide.front.signature": "Signature",
      "imageRedactor.guide.front.photo": "Photo",
      "imageRedactor.guide.front.dob": "DOB (if not required)",
      
      // Buttons and actions
      "imageRedactor.button.redact": "Redact",
      "imageRedactor.button.undo": "Undo",
      "imageRedactor.button.watermark": "Watermark",
      "imageRedactor.button.reset": "Reset",
      "imageRedactor.button.save": "Save",
    },
  },
};

const savedLanguage = localStorage.getItem("language") || "nl"; // Default to dutch if no language is saved

i18n
  .use(HttpBackend)
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources,
    lng: savedLanguage, // Default language
    fallbackLng: "nl", // Fallback language if the selected language translation is not available
    interpolation: {
      escapeValue: false, // React already does escaping
    },
  });

export default i18n;
